export default __webpack_public_path__ + "static/GoCardless_Logo_Negative_RGB-96e47e9cae5feefb8f3b4c3ca7050fec.png";